export const BASE_URL = 'https://admin.opinion-landscape.ch/';
//export const BASE_URL = 'http://localhost:8000/';
export const API_URL = BASE_URL + 'api/';
export const API_INFO = API_URL + 'survey/' + window.location.pathname.split('/')[1] + '/get-info/';
export const API_STEPS = API_URL + 'survey/' + window.location.pathname.split('/')[1] + '/';

